/* eslint-disable import/no-anonymous-default-export */
import { RouteObject } from "react-router-dom";
import {
  DISPUTE,
  DISPUTE_BUYER_DETAILS,
  DISPUTE_SELLER_DETAILS,
  
} from "../../constants/urls";

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    path: DISPUTE,
    lazy: () => import("./routes/DisputeList"),
  },
  {
    path: DISPUTE_SELLER_DETAILS,
    lazy: () => import("./routes/DisputeSellersDetails"),
  },
  
] as RouteObject[];
